<template>
  <div>
    <div class="content-title">
      ידעת שכל כניסה לשירות
      משפרת את התזרים שלך?
    </div>
    <div class="content-text">
      <div>
        לפי מחקר שביצעה חברת ERI - לקוחות שנכנסים יותר רואים צמיחה מהר יותר.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FinalPeriodContent',
};
</script>

<style lang="scss" scoped>

  .content-text {
    line-height: 1.5;
  }

  .content-title {
    margin-bottom: 16px;
    font-family: GretaSans,serif;
    font-size: 24px;
    line-height: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/trial/variants/FinalPeriodContent.vue